"use client";
import { useLocation, useParams } from "react-router-dom";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import { useEffect } from "react";
import { getAllNews, getNewsById } from "../../../services/newsServices";
import NewsDetailsData from "../../../components/admin/news/NewsDetailsData";
import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";

const NewsDetailsAdmin = () => {
  useEffect(() => {
    document.title = "News Details | Society of Aquaculture Professionals";
  }, []);

  const id = useParams().id;
  const title = useParams().title;

  const token = Cookies.get("token");
  const email = Cookies.get("email");
  const role = Cookies.get("role");
  const isLoggedIn = token && email && role;

  const {
    data: news,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["news", id],
    queryFn: () => getNewsById(id),
    enabled: !!id,
  });

  const {
    data: allNews,
    isLoading: allNewsLoading,
    isError: allNewsError,
  } = useQuery({
    queryKey: ["all-news"],
    queryFn: () =>
      getAllNews({ limit: 3, visibility: isLoggedIn ? "" : "public" }),
  });

  const location = useLocation();

  const formattedTitle = decodeURIComponent(title.replace(/\+/g, " "));

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar */}
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto w-full">
              <div className="flex items-start w-full gap-2">
                <button
                  onClick={() => window.history.back()}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm hover:shadow-md transition-shadow"
                  title="Go back"
                >
                  <span className="text-gray-600 text-lg">←</span>
                </button>{" "}
                <Header
                  title={`New Details:${formattedTitle}`}
                  desc={`Detailed  information about "${formattedTitle}"`}
                />
              </div>
              <NewsDetailsData
                news={news?.data}
                isLoading={isLoading}
                isError={isError}
                relatedNews={allNews?.data?.items || []}
                relatedLoading={allNewsLoading}
                relatedError={allNewsError}
                formattedTitle={formattedTitle}
              />{" "}
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default NewsDetailsAdmin;
